import './App.css';
import {useEffect, useState} from "react";
import _ from 'lodash'
import dayjs from "dayjs";
import { getMembers } from './api/index'

function Inquiry(props) {
  const end = props.location.state.end
  const [entry, setEntry] = useState('')
  const [entries, setEntries] = useState([])
  const [members, setMembers] = useState([])
  const [done, setDone] = useState(false)

  useEffect(() => {
    (async () => {
      const members = getMembers()
      setMembers(members)
      console.log(members)
    })()
  }, [])

  const toTop = () => {
    document.location.href = '/'
  }

  const canNotAdd = () => {
    if (entry === '') {
      return true
    }
    if (!getMember(entry)) {
      return true
    }
    return already()
  }
  const getMember = (number) => {
    const a = _.find(members, { number })
    console.log(number)
    console.log(a)
    return _.find(members, { number })
  }
  const already = () => {
    return _.find(entries, { number: entry })
  }

  const addMembers = () => {
    setEntries([...entries, getMember(entry)])
    setEntry('')
  }

  const cancel = (toCancel) => {
    // eslint-disable-next-line no-restricted-globals
    if (!confirm(`${toCancel.name}(${toCancel.number}) さんの申込を取り消してもよいですか？`)) {
      return
    }
    setEntries(entries.filter((m) => {
      return m !== toCancel
    }))
  }

  const inquiry = () => {
    setEntries(_.shuffle(entries))
    setDone(true)
    setEntry('')
  }

  const dayOf = (day) => {
    return dayjs(day).format('YYYY年MM月DD日HH時MM分')
  }

  return (
    <>
      <div className="App">
        <a className='backButton' onClick={toTop}>戻る</a>
        <header className="App-header">
          <h1>抽選</h1>
        </header>
        <div className="App-body">
          <div>
            抽選締切：{ dayOf(end) }
          </div>
          <div>
            {
              !done &&
              <>
                <div>
                  {
                    already() &&
                    <div>申込済みです</div>
                  }
                  <input className={'input-apply'} type={'number'} value={entry} onInput={(e) => setEntry(e.target.value)}/>
                  <button disabled={canNotAdd()} onClick={addMembers}>申込</button>
                </div>
              </>
            }
            {
              !done &&
              <>
                <button className={'inquiryButton'} disabled={entries.length === 0} onClick={inquiry}>抽選する</button>
              </>
            }
            {
              done &&
              <>
                <div>
                  抽選が終わりました。結果はスクリーンショットで保存してください。
                </div>
              </>
            }
          </div>
          <div>
            <table className={'table'}>
              <thead>
              <tr>
                <th>
                  {
                    done &&
                    <>
                      <span>当選順位</span>
                    </>
                  }
                </th>
                <th>申込者</th>
              </tr>
              </thead>
              <tbody>
              {
                entries.map((m, i) => {
                  return (
                    <tr key={i}>
                      <td>
                        {
                          !done &&
                          <>
                            <button onClick={() => cancel(m)}>取り消し</button>
                          </>
                        }
                        {
                          done &&
                          <>
                            <span>{i+1}</span>
                          </>
                        }
                      </td>
                      <td>
                        {
                          m.number === entry &&
                          <>
                            <span className='error'>{m.name}({m.number})</span>
                          </>
                        }
                        {
                          m.number !== entry &&
                          <>
                            <span>{m.name}({m.number})</span>
                          </>
                        }
                      </td>
                    </tr>
                  )
                })
              }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

export default Inquiry;
